import { call, put, takeEvery, select } from "redux-saga/effects";
import { types } from "../action-types";
import {
    fetchUserProfileFailure,
    fetchUserProfileSuccess,
} from "../actions";
import {
    fetchProfileURL, getMyABSAPI,
} from "../../API/API";

function* fetchProfileSaga(request) {
    try {
        const response = yield call(() => fetchProfileURL(request.payload)); // API Backend
        if (response.data.status === true) {
            const ProfileImageKey = response.data.data.body.user.Profiles.PictureUrl
            const firstName = response.data.data.body.user.Profiles.FirstName;
            // console.log('FetchProfileSaga check response',response.data.data.body.user.Profiles.PictureUrl);
            localStorage.setItem('profilePicture',JSON.stringify(ProfileImageKey))
            localStorage.setItem('profileName',JSON.stringify(firstName))
            yield put(fetchUserProfileSuccess(response.data.data.body.user));
        } else {
            yield put(fetchUserProfileFailure(response.data.error));
        }
    } catch (error) {
        console.log(error);
        yield put(fetchUserProfileFailure(error));
    }
}

function* fetchABSSaga() {
    try {
        const response = yield call(getMyABSAPI);
        yield put({type: types.GET_ABS_ACCOUNTS_SUCCESS, payload: response.data});
    }    
    catch (error) {
        yield put({type: types.GET_ABS_ACCOUNTS_FAILURE, error});
    }
}

export function* watchProfileSaga() {
    yield takeEvery(types.FETCH_PROFILE_INIT, fetchProfileSaga);
}
export function* watchGetABsSaga() {
    yield takeEvery(types.GET_ABS_ACCOUNTS, fetchABSSaga);
}
